var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pajamas:task-done"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 211",
    x: 4,
    y: 5,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#E3E4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 839",
    d: "M8 12.6667C8.38095 13 11.0476 15 11.0476 15L16 10",
    stroke: "#202E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.38d18afc67ee1b276d4279c056d99752.svg";
export { ForwardRef as ReactComponent };